import { FC, useEffect, useState } from 'react';
import { useMethods } from '@lhb/hook';
import { urlParams } from '@lhb/func';
import { getShareContent } from '@/common/api/common';
import { getModelClusterShareOverView, getModelClusterShareDetail, areaOverview } from '@/common/api/siteselectionmap';
import styles from './entry.module.less';
import SkeletonMapDetail from '@/common/components/Skeleton/SkeletonMapDetail';
import V2Container from '@/common/components/Data/V2Container';
import Top from './components/Top';
import Main from './components/Main';
import dayjs from 'dayjs';
import { setCookie } from '@lhb/cache';
import { getModelClusterDetail } from '@/common/api/networkplan';
import { SemirModelCode } from '@/views/youth/pages/map/ts-config';

const Siteselectionmapb: FC<{}> = () => {
  const shareId = urlParams(location.search)?.shareId;
  const [shareParams, setShareParams] = useState<any>({});
  const [loading, setLoading] = useState<boolean>(true); // 加载中
  const [detail, setDetail] = useState<any>({}); // 详情信息
  const [overViewData, setOverViewData] = useState<any>(); // 概览数据
  const [isSemirModel, setIsSemirModel] = useState<boolean>(false);
  useEffect(() => {
    shareId && methods.loadShareParams();
  }, [shareId]);
  const methods = useMethods({
    /**
     * 加载分享参数
     * @deprecated 如果有修改这块逻辑，请更换使用 src/common/hook/useGetShareContent.ts，并修改 useGetShareContent 中的逻辑
     */
    loadShareParams: async () => {
      const params: any = {
        id: shareId
      };
      const res = await getShareContent(params);
      const { content } = res || {};
      const result = content ? JSON.parse(content) : {};
      if (!Object.keys(result)) return;
      const { failureTime, token, } = result;
      if (dayjs().isAfter(failureTime)) {
        location.href = '/share/failure';
        return;
      }
      if (token) { // 服务端生成的临时token
        setCookie('flow_share_token', token);
        result && setShareParams(result);
        setTimeout(() => {
          methods.loadData(result);
        }, 100);
        return;
      }
      result && setShareParams(result);
      methods.loadData(result);
    },
    loadData: (params: any) => {
      setLoading(true);
      const _params: any = {
        id: params?.id,
        modelConfigId: params?.modelConfigId
      };
      if (params?.tenantId) {
        _params.tenantId = +params.tenantId;
      }
      Promise.all([
        params?.token ? getModelClusterDetail(_params) : getModelClusterShareDetail(_params),
        params?.token ? areaOverview(_params) : getModelClusterShareOverView(_params),
      ]).then(([detailRes, overview]) => {
        setDetail(detailRes);
        const { modelConfigCode } = overview || {};
        setIsSemirModel(modelConfigCode === SemirModelCode);
        setOverViewData(overview);
      }).finally(() => {
        setLoading(false);
      });
    },
  });

  return (
    <>
      {loading
        ? <SkeletonMapDetail/>
        : <V2Container
          // 容器上下padding 0， 所以减去就是0
          style={{ height: '100vh' }}
          extraContent={{
            top: <Top
              detail={detail}
              overViewData={overViewData}
              shareParams={shareParams}
              isSemirModel={isSemirModel}
            />,
          }}
          className={styles.container}
        >
          <Main
            // viewChanceDetail={viewChanceDetail}
            // drawerData={drawerData}
            shareParams={shareParams}
            detail={detail}
            overViewData={overViewData}
            isSemirModel={isSemirModel}
            // historyVisible={historyVisible}
            // isMallType={isMallType}
            // modelConfigId={modelConfigId}
            // setHistoryVisible={setHistoryVisible}
            // showCreateDrawer={showCreateDrawer}
            // setShowCreateDrawer={setShowCreateDrawer}
            // getDetail={methods.getDetail}
            // pointDrawerData={pointDrawerData}
            // setPointDrawerData={setPointDrawerData}
            // configSwitch={configSwitch}
            // setGatherClientPoint={setGatherClientPoint}
            // gatherList={gatherList}
            // gatherClientLegendList={gatherClientPoint?.legendList}
          />
        </V2Container>
      }
    </>
  );
};

export default Siteselectionmapb;
